<template>
	<div class="row result_row">

		<div class="col-xl-2 col-lg-2 col-md-2 col-sm-12 thumbnail_section">
			<b-btn class="thumbnail_container ace_sec" @click.stop="parent.goToCareerDetail(source)" :aria-label="source.name + ' thumbnail'">
				<img v-if="source.thumbnailURI" :id="'img_' + source.uuid" :class="parent.setImageWidth(source.uuid)" v-bind:src="source.thumbnailURI" :alt="source.name + ' thumbnail'" onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
				<div v-else class="thumbnail_default ico-career"></div>
			</b-btn>
		</div>

		<div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 entity_detail_section" :class="parent.updateTitleHeight(index)">
			<div class="row">

				<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
					<div class="row">

						<div class="col-12 title_row">
							<!--
							<span class="icon icon-career"></span>
							-->
							<span class="title ace_sec_txt" v-on:mouseover="parent.checkTitleLength(index)">
								<a href="javascript://" class="title_txt" :id="'entityName_' + index" @click.stop="parent.goToCareerDetail(source)" :aria-label="source.name">{{source.name}}</a>
							</span>

							<template v-if="parent.titlePopoverEnabled">
								<b-popover :target="'entityName_' + index" triggers="hover" placement="top" class="title_popup" :container="'entityNameContainer_' + index">
									<div class="title_container">
								  	{{source.name}}
									</div>
							  </b-popover>
							  <div :id="'entityNameContainer_' + index" class="title_container_popup"></div>
							</template>

              <template v-if="isBookmarkEnabled">
  							<span
  								v-if="parent.showBookmarkOnResult && parent.isBookmarked(source)"
  								@click.stop.prevent="parent.deleteCareerBookmark(source)"
  								class="ic_bm_container bookmarked ace_sec_txt"
  								title="remove this career from bookmark">
  								<span class="icon ic8-bookmark3"></span>
  							</span>
  							<span
  								v-else-if="parent.showBookmarkOnResult && !parent.isBookmarked(source)"
  								@click.stop.prevent="parent.bookmarkCareer(source)"
  								class="ic_bm_container ace_sec_txt"
  								title="bookmark this career">
  								<span class="icon ic8-bookmark3"></span>
  							</span>
              </template>
						</div>

						<div class="col-12 description ace_sec_txt" v-if="parent.showDescriptionOnResult && source.description" :id="'entityDesc_' + index">
							<div class="desc_txt">{{ source.description }}</div>
						</div>

						<div class="col-12 lnk_container" :class="parent.showMoreDescLnk(index)">
	            <b-link v-b-modal="'entityDescModal_' + index">more</b-link>
	          </div>

	          <b-modal size="xl" :id="'entityDescModal_' + index" :title="source.name" ok-only ok-title="close">

	            <div class="row">

	              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 thumbnail_section">
									<div class="thumbnail_container ace_sec" @click.stop="parent.goToCareerDetail(source)" :aria-label="source.name + ' thumbnail'">
										<img v-if="source.thumbnailURI" :id="'img_' + source.uuid" :class="parent.setImageWidth(source.uuid)" v-bind:src="source.thumbnailURI" alt="Img"  onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
										<div v-else class="thumbnail_default ico-career"></div>
									</div>
	              </div>

	              <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12">
	                <div v-html="source.description"></div>
	              </div>

	            </div>

	          </b-modal>

					</div>
				</div>



			</div>
		</div>

		<div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 other_info">
			<div class="row">

				<div v-if="parent.showMedianIncomeOnResult" class="col-xl-4 col-lg-4 col-md-4 col-sm-12 list_info_row">
					<div class="info_title">{{parent.medianIncomeResultLabel}}</div>
					<div class="info_val ace_sec_txt" v-if="source.medianIncomePerYear" :aria-label="'median income is ' + parent.currencyLabel + source.medianIncomePerYear + ' for this career'">
					  {{parent.currencyLabel}}<span v-html="parent.addCommaInNumber(source.medianIncomePerYear)"></span>
					</div>
					<div class="info_no_val ace_sec_txt pl-0" v-else aria-label="There may not be sufficient job data from employer and government sources for emerging or highly specialized careers.">
            <span class="no_data_msg1">Data Unavailable</span>
          </div>
				</div>

				<div v-if="parent.showJobPostingsOnResult" class="col-xl-4 col-lg-4 col-md-4 col-sm-12 list_info_row">
					<div class="info_title">{{parent.jobPostingsResultLabel}}</div>
					<div class="info_val ace_sec_txt" v-if="source.openings" :aria-label="'total job postings are ' + source.openings + ' for this career'">
						<span v-html="parent.addCommaInNumber(source.openings)"></span>
					</div>
					<div class="info_no_val ace_sec_txt pl-0" v-else aria-label="There may not be sufficient job data from employer and government sources for emerging or highly specialized careers.">
            <span class="no_data_msg1">Data Unavailable</span>
          </div>
				</div>

				<div v-if="parent.showGrowthRateOnResult" class="col-xl-4 col-lg-4 col-md-4 col-sm-12 list_info_row">
					<div class="info_title"> {{parent.growthRateResultLabel}} </div>
					<div class="info_val ace_sec_txt" v-if="source.growth" :aria-label="'growth rate is ' + source.growth + ' for this career'">{{parseFloat(source.growth).toFixed(1)}}</div>
					<div class="info_no_val ace_sec_txt pl-0" v-else  aria-label="There may not be sufficient job data from employer and government sources for emerging or highly specialized careers.">
            <span class="no_data_msg1">Data Unavailable</span>
          </div>
				</div>

				<div v-if="parent.showCalculateRequiredSkillOnResult && parent.isStudentLogin && parent.planningStream" class="col-xl-4 col-lg-4 col-md-4 col-sm-12 list_info_row">
					<span class="lnk_req_credit ace_sec_txt" :id="'skillProgressPopup_' + source.uuid" @click="parent.calculateSkillProgressClicked(source, $event)">Calculate Required Skills</span>
				</div>

			</div>
		</div>

	</div>
</template>

<script>
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'careerItem',
  props: {
    parent: {
      type: Object
    },
    index: {
      type: Number
    },
    source: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    ...mapState({
      'packages': state => state.institution.packages,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'institution': state => state.institution.institution
    }),
    isBookmarkEnabled () {
      let bookmarkFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.BOOKMARK_FEATURE_ID]
      if (bookmarkFeature && bookmarkFeature.enabled) {
        return true
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/explore/components/CareerItem.vue